export const STORE_SUPPORT_HEALTH_REQUEST = "STORE_SUPPORT_HEALTH_REQUEST";
export const STORE_SUPPORT_HEALTH_SUCCESS = "STORE_SUPPORT_HEALTH_SUCCESS";
export const STORE_SUPPORT_HEALTH_ERROR = "STORE_SUPPORT_HEALTH_ERROR";
